module.exports = __webpack_public_path__ + "img/2_CN_ChineseMicrosite_Homepage_HeroImage.21a34918.jpg";